import { HtmlHeadInclude } from '@msdyn365-commerce/core-internal';
import React, { useEffect, useRef } from 'react';
import { appendScriptClientSide } from '../../shared/functions/dom-operations';
import { UserCentricsService } from '../../integrations/userCentrics/UserCentricsService';
import { registerSpriiCheckoutHandler } from './helpers/sprii-checkout-handler';
import { ICusSpriiIntegrationProps } from './cus-sprii-integration.props.autogenerated';

const SpriiIntegration = (props: ICusSpriiIntegrationProps<never>) => {
    const { config, context } = props;
    const { actionContext } = context;
    const { mainScriptSrc, isEnabled } = config;

    const hasFired = useRef(false);

    const shouldRun = isEnabled && mainScriptSrc;

    useEffect(() => {
        if (!shouldRun || hasFired.current) {
            return;
        }

        return UserCentricsService.subscribeToConsentSettled(() => {
            if (hasFired.current) {
                return;
            }

            hasFired.current = true;
            registerSpriiCheckoutHandler(actionContext);
            appendScriptClientSide(mainScriptSrc);
        });
    }, [mainScriptSrc, actionContext, shouldRun]);

    if (!shouldRun) {
        return <></>;
    }

    return (
        <HtmlHeadInclude>
            <link rel='preload' as='script' href={mainScriptSrc} />
        </HtmlHeadInclude>
    );
};

export default SpriiIntegration;
